jQuery(document).ready(function () {
    jQuery('.activity__share-button').click(function () {
        return popitup(jQuery(this).attr('href'));
    });
});

function popitup(url) {
    var w = 400;
    var h = 300;
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    newwindow = window.open(url, 'name', 'height=' + h + ',width=' + w + ',left=' + left + ',top=' + top);
    if (window.focus) { newwindow.focus() }
    return false;
}